export enum eQuizType {
  GRADED_QUIZ = 1,
  PRACTICE_QUIZ = 2,
  GRADED_SURVEY = 3,
  PRACTICE_SURVEY = 4,
}
